import { Operator } from 'react-querybuilder'
import { exportFormatDate, renderDate, renderLink } from '../DisplayValues'
export { renderLink }
export { lookupPipeline } from '../helpers'
export type { CustomField } from '../helpers'

export const textOperators: Operator[] = [
  { name: '=', label: 'equals' },
  { name: '!=', label: 'not equals' },
  { name: 'contains', label: 'contains' },
  { name: 'beginsWith', label: 'begins with' },
  { name: 'endsWith', label: 'ends with' },
  { name: 'in', label: 'in' },
  { name: 'notIn', label: 'not in' },
  { name: 'null', label: 'is empty' },
  { name: 'notNull', label: 'is not empty' }
]

export const numberOperators: Operator[] = [
  { name: '=', label: 'equals' },
  { name: '!=', label: 'not equals' },
  { name: '<', label: 'less than' },
  { name: '<=', label: 'less than or equal' },
  { name: '>', label: 'greater than' },
  { name: '>=', label: 'greater than or equal' },
  { name: 'between', label: 'between' },
  { name: 'notBetween', label: 'not between' },
  { name: 'null', label: 'is empty' },
  { name: 'notNull', label: 'is not empty' }
]

export const dateOperators: Operator[] = [
  { name: '=', label: 'on' },
  { name: '!=', label: 'not on' },
  { name: '<', label: 'before' },
  { name: '<=', label: 'on or before' },
  { name: '>', label: 'after' },
  { name: '>=', label: 'on or after' },
  { name: 'between', label: 'between' },
  { name: 'notBetween', label: 'not between' },
  { name: 'null', label: 'is empty' },
  { name: 'notNull', label: 'is not empty' }
]

export const booleanOperators: Operator[] = [
  { name: '=', label: 'is' }
]

export const fieldProps = {
  text: { operators: textOperators },
  number: { inputType: 'number' as const, operators: numberOperators },
  date: { inputType: 'date' as const, operators: dateOperators, render: renderDate, exportFormat: exportFormatDate },
  boolean: { valueEditorType: 'checkbox' as const, operators: booleanOperators }
}
